const HTMLTitle = {
  '/auth': 'html_title_intro',
  '/auth/login': 'html_title_auth_mobile',
  '/auth/otp': 'html_title_auth_code',
  '/register': 'html_title_register_steps',
  '/register-info3': 'html_title_initial_deposit',
  '/register-info4': 'html_title_register_complete',
  '/main/map': 'html_title_map',
  '/main/map/reserved': 'html_title_reserved',
  '/main/map/damage-list': 'html_title_damage_list',
  '/main/damage-report': 'html_title_damage_report',
  '/main/map/sheetStart': 'html_title_start',
  '/main/map/drive': 'html_title_drive',
  '/payment': 'html_title_payment',
  '/main/billfine': 'html_title_billfine',
  '/main/dashboard': 'html_title_dashboard',
  '/main/dashboard/account-info': 'html_title_profile',
  '/main/dashboard/invite-friends': 'html_title_invite',
  '/main/dashboard/add-credit': 'html_title_credit',
  '/main/dashboard/buy-packages': 'html_title_buy_packages',
  '/main/dashboard/payment-history': 'html_title_payment_history',
  '/main/dashboard/trip-history': 'html_title_trip_history',
  '/main/dashboard/trip-info': 'html_title_trip_info',
  '/main/dashboard/package-list': 'html_title_gift_list',
  '/main/dashboard/support': 'html_title_contact_us',
};

export default HTMLTitle;
